export default __webpack_public_path__ + "static/media/baby3.53901c0e.jpg";